import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { Routes } from '@/router/router.const';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import dashboard_Icon from '@/assets/images/icons/sideMenuIcons/nav_dashboard.svg';
import dashboard_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_dashboard_selected.svg';
import agents_Icon from '@/assets/images/icons/sideMenuIcons/nav_agent_list.svg';
import agents_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_agent_list_selected.svg';
import users_Icon from '@/assets/images/icons/sideMenuIcons/nav_users.svg';
import users_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_users_selected.svg';
import settings_Icon from '@/assets/images/icons/sideMenuIcons/nav_settings.svg';
import settings_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_settings_selected.svg';
import license_Icon from '@/assets/images/icons/sideMenuIcons/nav_license.svg';
import workloads_Icon from '@/assets/images/icons/sideMenuIcons/nav_builds.svg';
import workloads_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_builds_selected.svg';
import license_Icon_Selected from '@/assets/images/icons/sideMenuIcons/nav_license_selected.svg';
import getting_started_selected from '@/assets/images/icons/sideMenuIcons/nav_getting_started_selected.svg';
import getting_started from '@/assets/images/icons/sideMenuIcons/nav_getting_started.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'sidemenu-item',
  props: {
    label: null,
    route: null,
    activeRoutes: null,
    miniState: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  route: Routes;
  activeRoutes?: Routes[];
  miniState: boolean;
}



const iconsMap: {
  default: Partial<Record<Routes, any>>;
  active: Partial<Record<Routes, any>>;
} = {
  default: {
    [Routes.GettingStarted]: getting_started,
    [Routes.Dashboard]: dashboard_Icon,
    [Routes.Agents]: agents_Icon,
    [Routes.Builds]: workloads_Icon,
    [Routes.Users]: users_Icon,
    [Routes.Settings]: settings_Icon,
    [Routes.License]: license_Icon,
  },
  active: {
    [Routes.GettingStarted]: getting_started_selected,
    [Routes.Dashboard]: dashboard_Icon_Selected,
    [Routes.Agents]: agents_Icon_Selected,
    [Routes.Builds]: workloads_Icon_Selected,
    [Routes.Users]: users_Icon_Selected,
    [Routes.Settings]: settings_Icon_Selected,
    [Routes.License]: license_Icon_Selected,
  },
};

const router = useRouter();
const route = useRoute();
const isActive = computed(() => route.name === props.route || (props.activeRoutes && props.activeRoutes.includes(route.name as Routes)));
const icon = computed(() => (isActive.value ? iconsMap.active[props.route] : iconsMap.default[props.route]));

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menuItemBackground", { 'menuItemActive ibf-h4': _unref(isActive), wide: !__props.miniState, mini: __props.miniState }])
  }, [
    _createVNode(_component_q_item, {
      id: `sidebar-${props.route}`,
      clickable: "",
      class: "focus-be-gone",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: props.route })))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createElementVNode("img", { src: _unref(icon) }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id"])
  ], 2))
}
}

})